<template>
  <el-dialog :title="formData.id ? '编辑角色' : '新增角色'" :visible.sync="_dialogVisible" :close-on-click-modal="false" @close="closeDialog">
    <el-form :model="formData" ref="listForm">
      <el-form-item label="角色名称" label-width="120px" prop="roleName" :rules="[{ required: true, message: '请输入角色名称', trigger: 'blur' }]">
        <el-input v-model="formData.roleName" :maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="备注" label-width="120px">
        <el-input type="textarea" :rows="2" :maxlength="200" placeholder="请输入备注" v-model="formData.remark" show-word-limit class="remark-wrapper"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
const defaultFormData = {
  roleName: "",
  remark: "",
};

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
      required: true,
    },
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  watch: {
    _dialogVisible(val) {
      if (val) {
        if (this.id) {
          this.loadRoleDetail();
        } else {
          this.formData = Object.assign({}, defaultFormData);
        }
      }
    },
  },
  data() {
    return {
      formData: Object.assign({}, defaultFormData),
      tableLoading: false,
      btnLoading: false,
    };
  },
  methods: {
    /**
     * 加载详情
     */
    loadRoleDetail() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + `/role/roleDetail/${this.id}`,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.formData = res.body.data.data;
            } else {
              this.formData = {};
            }
          } else {
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 提交
     */
    handleSubmit() {
      this.$refs.listForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          this.$http({
            url: this.form.id ? global.apiUrl + "/role/editRole" : global.apiUrl + "/role/addRole",
            method: this.form.id ? "PUT" : "POST",
            body: this.formData,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this._dialogVisible = false;
                this.$emit("onSuccess");
              } else {
              }
              this.btnLoading = false;
            })
            .catch(err => {
              this.btnLoading = false;

              console.error(err);
            });
        }
      });
    },
    /**
     * 重置表单项，移除校验结果
     */
    closeDialog() {
      this.$refs.listForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.remark-wrapper {
  textarea {
    overflow-y: auto;
    max-height: 180px;
  }
}
</style>
